import { render, staticRenderFns } from "./PowderStats2021.vue?vue&type=template&id=6ba4a3ae&"
import script from "./PowderStats2021.vue?vue&type=script&lang=js&"
export * from "./PowderStats2021.vue?vue&type=script&lang=js&"
import style0 from "./PowderStats2021.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports